import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CriteriaSubmission from "./components/CriteriaSubmission/criteriaSubmission";
import Header from "./components/Layout/header";
import { Routes, Route } from "react-router-dom";
import AuthScreen from "./components/auth/auth_screen";
import RequireAuth from "./components/auth/required_auth";
import { useSelector, useDispatch } from "react-redux";
import { dailyLimitReached, logOut, selectDailyLimitReached, selectIsUserInActive, userInActive, selectCurrentUser } from "./slices/auth";
import Privacy from "./components/privacy";
import Terms from "./components/terms";
import QuestionsReview from "./components/QuestionsReview/QuestionsReview";
import Worksheet from "./components/QuestionsReview/Worksheet";
import ToolSelection from "./components/ToolSelection/ToolSelection";
import PassageReview from "./components/PassageReview/PassageReview";
import GradingTool from "./components/GradingTool/GradingTool";
import InActiveInfoModal from "./components/UI/inactive_info_modal/inactive_info_modal";
import CreateQuestions from "./components/CreateQuestions/CreateQuestions";
import ProtectedGradingTool from "./components/auth/protected_grading_tool";
import LoadGradingSession from "./components/GradingTool/LoadGradingSession";
import TextLevelingPage from "./components/TextLeveling/TextLevelingPage";
import CredentialingDashboard from "./components/Credentialing/CredentialingDashboard.jsx";
import BadgeModule from "./components/Credentialing/BadgeModule.jsx";
import ImpactStoryPage from "./components/Credentialing/ImpactStoryPage.jsx";
import ImpactStoriesPage from "./components/Credentialing/ImpactStoriesPage.jsx";
import BadgeDashboard from "./components/badges/BadgeDashboard.jsx";
import BadgeVerificationPage from "./components/badges/BadgeVerificationPage.jsx";

function App() {
  const isLoggedin = useSelector((state) => state.auth.isloggedin);
  const currentUser = useSelector(selectCurrentUser);
  const isDailyLimitReached = useSelector(selectDailyLimitReached)
  const isUserInActive = useSelector(selectIsUserInActive)
  const dispatch = useDispatch();
  const userGroup = currentUser?.userData?.user_options?.user_group;
  
  const handleLogout = () => {
    dispatch(logOut());
  };
  
  return (
    <>
    <Routes>
      <Route
        path="/"
        element={<Header isLoggedin={isLoggedin} logout={handleLogout} userGroup={userGroup} />}
      >
        {/* public routes */}
        <Route path="/" element={<AuthScreen isLoggedin={isLoggedin} />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/badges/verify/:credentialId" element={<BadgeVerificationPage />} />
        {/* protected routes */}
        <Route element={<RequireAuth isLoggedin={isLoggedin} />}>
          <Route path="toolSelection" element={<ToolSelection />} />
          <Route path="criteriaselection" element={<CriteriaSubmission />} />
          <Route path="questionsCriteria" element={<CreateQuestions />} /> 
          <Route path="questionsReview" element={<QuestionsReview />} />
          <Route path="worksheet" element={<Worksheet />} />
          <Route path="PassageReview" element={<PassageReview />} />
          <Route path="textLeveling" element={<TextLevelingPage />} />
          <Route path="credentialing" element={<CredentialingDashboard />} />
          <Route path="credentialing/modules/:moduleId" element={<BadgeModule />} />
          <Route path="credentialing/impact-story" element={<ImpactStoryPage />} />
          <Route path="credentialing/impact-stories" element={<ImpactStoriesPage />} />
          <Route path="badges" element={<BadgeDashboard />} />
          <Route path="load-session/:sessionId" element={<LoadGradingSession />} />
          <Route element={<ProtectedGradingTool isLoggedin={isLoggedin} />}>
            <Route path="grading/:step" element={<GradingTool />} />
          </Route>
        </Route>
      </Route>
    </Routes>
    <InActiveInfoModal isOpen={isUserInActive} continueHandler={() => dispatch(userInActive(false))} />
    <InActiveInfoModal
        continueHandler={() => dispatch(dailyLimitReached(false))}
        isOpen={isDailyLimitReached}
        btnText={"Okay"}
        heading="Daily usage limit reached"
        message="You've reached your daily usage limit. Your account has temporarily been suspended. If you believe this is an error, please reach out to us at "
      />
    </>
  );
}

export default App;
